module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/error-circle-5f32afabd37d3b518405fa4945c1662f.svg";